import React from "react";

import { format } from "date-fns";

import { DateRangeOptions } from "@fartherfinance/frontend/utils/dateUtils";

import DeletableChip from "@src/sharedComponents/DeletableChip/DeletableChip";

import { FiltersAppliedSchema } from "./DateRangeFilter";

interface DateRangeFilterChipProps {
  filters: FiltersAppliedSchema;
  onClear: () => void;
  onPress: () => void;
  dateRangeOption: DateRangeOptions;
}

const DateRangeFilterChip: React.FC<DateRangeFilterChipProps> = ({
  dateRangeOption,
  filters,
  onClear,
  onPress,
}) => {
  if (dateRangeOption !== DateRangeOptions.CUSTOM) {
    return (
      <DeletableChip
        label={`${dateRangeOption}`}
        onPress={onPress}
        onClear={onClear}
      />
    );
  }

  const { dateFrom, dateTo } = filters;
  if (!dateFrom || !dateTo) {
    return null;
  }

  return (
    <DeletableChip
      label={`Created ${format(dateFrom, "MM/dd/yyyy")} - ${format(
        dateTo,
        "MM/dd/yyyy"
      )}`}
      onPress={onPress}
      onClear={onClear}
    />
  );
};

export default DateRangeFilterChip;
